import { apiService } from './apiService';

export const generalList2SpotService = {
  async getAll(params?: { updatedSince?: string }) {
    const queryParams = new URLSearchParams();
    if (params?.updatedSince) queryParams.append('updatedSince', params.updatedSince);
    const query = queryParams.toString();
    return await apiService.get(`/general-list-2-records/spot-status${query ? `?${query}` : ''}`, { timeoutMs: 300000 });
  },

  async getDriverActiveShipments(driverId: string) {
    return await apiService.get(`/general-list-2-records/${driverId}/active-shipments`);
  },
};
